import React, { useState, useEffect } from "react";
import Header from './components/header.js';
import Heading from './components/heading.js';
import Footer from './components/footer.js';
import Rotation from './components/rotation.js';
import RotationMobile from './components/rotationMobile.js';
import './App.css';

const Home = () => {
    const [isMobile, setIsMobile] = useState(
        window.innerWidth < 800
    );

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 800);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className="body">
            <div className="grid-pattern">
                <div className="shadow">
                    <Header />
                    <Heading />
                    {isMobile ? <RotationMobile /> : <Rotation />}
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default Home;